import {ActionContext} from "vuex";
import {State as RootState} from "@/store";
import {getStoreAccessors} from "vuex-typescript";
import {TopicState} from "@/store/Topic/TopicState";
import {Post, Topic} from "@/repository/messagehub.dtos";
import {postRecord, PostState} from "@/store/Posts";
import {PostsApi} from "@/repository/PostsApi";

type TopicRecordContext = ActionContext<TopicState, RootState>;

export const topicRecord = {
    namespaced: true,

    state: {
        topics: [],
        selectedTopic: null
    },

    getters: {
        getTopics(state: TopicState): any{
            let topics =  state.topics
            if (!topics){
                return []
            }
            else{
                return state.topics
            }
        },
        getselectedTopic(state: TopicState): any {
            return state.selectedTopic
        }
    },

    mutations: {
        mutateAddTopic: function(state: TopicState, newTopic: Topic){
            console.log('mutating topics')
            if (state.topics !=null && state.topics.length >0){
                state.topics.push(newTopic)
                state.selectedTopic = newTopic
            }
            else{
                state.topics = []
                state.topics.push(newTopic)
                state.selectedTopic = newTopic
            }

        },
        mutateDeleteTopic: function(state: TopicState, deletedTopic: Topic){
          if (state.topics !=null && state.topics.length >0)  {
              let idx:number = state.topics.indexOf(deletedTopic);
              if (idx != -1) {
                  state.topics.splice(idx,1)
                  state.selectedTopic = null
              }
          }
        },
        mutateInitializeTopics: function(state: TopicState, topics: Topic[]){
            state.topics = topics
            state.selectedTopic = null;

        },
        mutateSelectedTopicChanged:function(state: TopicState, selectedTopic: Topic){
            state.selectedTopic = selectedTopic
        },
        mutateUpdateTopic: function(state: TopicState, updatedTopic: Topic){

            if (state.topics !=null && state.topics.length >0)  {
                if (state.selectedTopic !=null){
                    let idx:number = state.topics.indexOf(state.selectedTopic);
                    if (idx != -1) {
                        state.topics.splice(idx,1)
                        state.topics.push(updatedTopic)
                        state.selectedTopic = null
                    }
                }
            }
            else{
                state.topics = []
                state.topics.push(updatedTopic)
            }
            state.selectedTopic = updatedTopic
        },
    },

    actions: {
        addTopic: function (context: TopicRecordContext, newTopic: Topic){
            commitAddTopic(context, newTopic)
        },
        deleteTopic: function (context: TopicRecordContext, deletedTopic: Topic){
            context.dispatch("postRecord/initializePosts", <Post[]> [], {root: true})
            commitDeleteTopic(context, deletedTopic)
        },
        initializeTopics: function (context: TopicRecordContext, topics: Topic[]){
            commitInitializeTopics(context, topics)
        },
        selectedTopicChanged: function (context: TopicRecordContext, selectedTopic: Topic){
            if (selectedTopic !=null){
                postApi.getPostsInTopic(selectedTopic.id).then(success=>{
                    context.dispatch("postRecord/initializePosts", <Post[]> success.data, {root: true})
                    commitSelectedTopicChanged(context, selectedTopic)
                })

            }

        },
        updateTopic: function (context: TopicRecordContext, updateTopic: Topic){
            commitUpdateTopic(context, updateTopic)
        },

    },
};
const { commit, read, dispatch } =
    getStoreAccessors<TopicState, RootState>("topicRecord");

const getters:any = topicRecord.getters;
export const getTopics:any = read(getters.getTopics);
export const getSelectedTopic:any = read(getters.getselectedTopic);

const actions: any = topicRecord.actions;
export const deleteTopic:any =dispatch(actions.deleteTopic)
export const initializeTopics:any =dispatch(actions.initializeTopics)
export const selectedTopicChanged:any =dispatch(actions.selectedTopicChanged)
export const addTopic:any =dispatch(actions.addTopic)
export const updateTopic:any =dispatch(actions.updateTopic)

const mutations:any = topicRecord.mutations;
export const commitDeleteTopic:any = commit(mutations.mutateDeleteTopic);
export const commitInitializeTopics:any = commit(mutations.mutateInitializeTopics);
export const commitSelectedTopicChanged:any = commit(mutations.mutateSelectedTopicChanged);
export const commitAddTopic:any = commit(mutations.mutateAddTopic);
export const commitUpdateTopic:any = commit(mutations.mutateUpdateTopic);

//channelApi

const postApi = new PostsApi()



